import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOT_VIEWABLE_EVENT_TYPE_LIST,
    CLEAR_NOT_VIEWABLE_EVENT_TYPE_LIST_ERROR,
    LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_REQUEST,
    LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_SUCCESS,
    LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOT_VIEWABLE_EVENT_TYPE_LIST,
    CLEAR_ERROR: CLEAR_NOT_VIEWABLE_EVENT_TYPE_LIST_ERROR,
    LOAD_REQUEST: LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_NOT_VIEWABLE_EVENT_TYPE_LIST_FAILURE
}